// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"618":"9bb60520","787":"056b36d9"}[chunkId] + ".chunk.js";
};